import { Skeleton } from "@mui/material";
import { generateData } from "utils/tableColumnData";

const data = (t) => {
  return {
    columns: [
      { name: t("users.user_id"), accessor: "userId", align: "center" },
      { name: t("users.email"), accessor: "email", align: "left" },
      { name: t("users.uuid"), accessor: "uuid", align: "left" },
      { name: t("users.created_at"), accessor: "createdAt", align: "left" },
      { name: t("users.roles"), accessor: "roles", align: "center" },
      { name: t("users.actions"), accessor: " ", align: "right" },
    ],
    skeletonRows: generateData(3, {
      userId: <Skeleton variant="text" sx={{ fontSize: "14px" }} width={40} />,
      email: <Skeleton variant="text" sx={{ fontSize: "14px" }} width={155} />,
      uuid: <Skeleton variant="text" sx={{ fontSize: "14px" }} width={260} />,
      roles: <Skeleton variant="text" sx={{ fontSize: "14px" }} width={70} />,
      createdAt: <Skeleton variant="text" sx={{ fontSize: "14px" }} width={100} />,
      [" "]: <></>,
    }),
  };
};

export default data;
